import { IText } from '../../../../forms/base/controls/content/Text';
import { RPDF } from '../../../react-pdf';

export const Text: IText = ({ text, isHiddenOnOverview }) => {
  if (isHiddenOnOverview) {
    return <RPDF.View />;
  }

  return (
    <RPDF.View minPresenceAhead={40} style={{ ...RPDF.tableStyles.divider, paddingTop: 4, paddingBottom: 4 }}>
      <RPDF.Text style={RPDF.typography.text8}>{text}</RPDF.Text>
    </RPDF.View>
  );
};
